import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { AdverseEventsProvider } from '../../providers/adverse-events/adverse-events';
import { PdfAdverseEventProvider } from '../../providers/pdf/pdfAdverseEvent';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-adverse-events',
  templateUrl: 'program-adverse-events.html',
})
export class ProgramAdverseEventsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  displayedColumns = ['ae_number', 'patient', 'program_patient_id', 'createdBy.name','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider,
    private dbAE: AdverseEventsProvider,
    public utility: UtilityProvider,
    public pdfAE: PdfAdverseEventProvider
  ){
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.dbAE
      .listAdverseEventsByProgram(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((aes) => {
        this.exportjson = aes;
        this.dataSource = new MatTableDataSource(aes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program adverse events and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Adverse Events'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'adverseevents.xlsx'); // initiate a file download in browser
  }

  viewAE(ae)  {
    this.pdfAE.createAdverseEventForm(this.program_id, this.program_name, ae);
    console.log('AE: ', ae);
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-adverse-events/program-adverse-events.ts